export const GET_USED_COUNTRIES = 'GET_USED_COUNTRIES';
export const GET_USED_COUNTRIES_START = `${GET_USED_COUNTRIES}_START`;
export const GET_USED_COUNTRIES_SUCCESS = `${GET_USED_COUNTRIES}_SUCCESS`;
export const GET_USED_COUNTRIES_FAIL = `${GET_USED_COUNTRIES}_FAIL`;

export function getUsedCountries() {
  return {
    type: GET_USED_COUNTRIES,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/countries`,
      method: 'get',
      params: {
        used: true,
        limit: 300,
      },
    },
  };
}
